export default __webpack_public_path__ + "static/media/male3.8e483a13.png";